import Rox from 'rox-browser';
import { getOS } from "@/helpers/getOs";

// import module flags permission
import { initFlagsWebinar } from "@/feature-flags/flags-webinar";
import { initFlagsShipment } from "@/feature-flags/flags-shipment";
import { initFlagsOrders } from "@/feature-flags/flags-orders";
import { initFlagsShipmentBulk } from "@/feature-flags/flags-shipment-bulk";
import { initFlagsMinipack } from "@/feature-flags/flags-minipack";
import { initFlagsShipmentSeamless } from "@/feature-flags/flags-shipment-seamless";
import { initFlagsMapsPickup } from "@/feature-flags/flags-maps-pickup";
import { initFlagsNewPaymentPage } from "@/feature-flags/flags-new-payment-page";
import { initFlagsWebsite } from "@/feature-flags/flags-website";
import { initFlagsWoodPacking } from "@/feature-flags/flags-wood-packing";
import { initFlagsQuarantine } from "@/feature-flags/flags-quarantine";
import { initFlagsHome } from "@/feature-flags/flags-home";
import { initFlagsShipmentBanner } from "@/feature-flags/flags-shipment-banner";
import { initFlagsDropoffAutoSelect } from "@/feature-flags/flags-dropoff-auto-select";

// eslint-disable-next-line no-unused-vars
export async function initRollout() {
  const options = {};

  // Register the flags
  // Cloudbees
  initFlagsWebinar();
  initFlagsShipment();
  initFlagsOrders();
  initFlagsShipmentBulk();
  initFlagsMinipack();
  initFlagsNewPaymentPage();
  initFlagsShipmentSeamless();
  
  // Unleash
  initFlagsWebsite();
  initFlagsMapsPickup();
  initFlagsShipmentBanner();
  initFlagsWoodPacking();
  initFlagsQuarantine();
  initFlagsHome();
  initFlagsDropoffAutoSelect();

  // Setup connection with the feature management environment key
  await Rox.setup(process.env.VUE_APP_ROLLOUT_KEY, options);

  Rox.setCustomStringProperty("user_operating_system", () => {
    return getOS();
  })
}
